/*** IMPORTS FROM imports-loader ***/
var jQuery = require("jquery");
var $ = require("jquery");

import React from 'react';
import {
  Tooltip,
  OverlayTrigger,
} from 'react-bootstrap';
import { connect } from 'react-redux';
import {
  injectIntl,
  FormattedMessage,
} from 'react-intl';
import CSSModules from 'react-css-modules';
import styles from 'loracoms/Refresher/styles.scss';

const propTypes = {
  onReload: React.PropTypes.func.isRequired,
  onOneClick: React.PropTypes.func,
  reloading: React.PropTypes.bool,
  interval: React.PropTypes.number,
  loops: React.PropTypes.number,
};

const defaultProps = {
  interval: 6,
  loops: 100,
  reloading: false,
  onOneClick: () => {},
};


class RefreshBtn extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      pinned: false,
      reloading: props.reloading,
    };
    this.handleReload = this.handleReload.bind(this);
    this.handleReloadPinned = this.handleReloadPinned.bind(this);
  }

  componentDidMount() {
    this.mounted = true;
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.reloading !== nextProps.reloading) {
      if (this.reloadingTimeout) {
        clearTimeout(this.reloadingTimeout);
      }
      const reloading = nextProps.reloading;
      if (reloading) {
        this.setState({ reloading });
      } else {
        setTimeout(() => {
          if (this.mounted) {
            this.setState({ reloading });
          }
        }, 1000);
      }
    }
  }

  componentWillUnmount() {
    this.mounted = false;
  }

  handleReload(e) {
    e.preventDefault();
    const { reloading } = this.state;
    if (!reloading) {
      this.setState({ pinned: false });
      this.props.onReload();
      this.props.onOneClick();
    } else {
      this.handleReloadPinned();
    }
  }

  handleReloadPinned(e) {
    if (e) {
      e.preventDefault();
    }
    const { interval, loops } = this.props;
    this.setState({
      pinned: true,
      pinnedLoops: 0,
    });

    const g = () => {
      const { pinned } = this.state;
      if (this.mounted && pinned) {
        this.props.onReload();
        const { pinnedLoops = 0 } = this.state;
        if (pinnedLoops < loops) {
          this.setState({
            pinnedLoops: pinnedLoops + 1,
          });
          setTimeout(g, interval * 1000);
        } else {
          this.setState({
            pinned: false,
          });
        }
      }
    };
    this.props.onReload();
    setTimeout(g, interval * 1000);
  }

  render() {
    const { interval, loops } = this.props;
    const { reloading, pinned, pinnedLoops } = this.state;
    let icon = 'glyphicons glyphicons-refresh';
    if (pinned) {
      icon = 'glyphicons glyphicons-synchronization';
    }
    if (reloading) {
      icon = `${icon} aisz-spin`;
    }

    const refresher = (
      <button
        onClick={this.handleReload}
        className="icon"
        styleName={`${pinned ? 'btn-link pinned' : 'btn-link'}`}
      >
        <span className={icon} />
      </button>
    );

    if (pinned) {
      const tooltip = (
        <Tooltip id="refresher-pinned-tooltip">
          <FormattedMessage id="lora.coms.refresher.pinned.tooltip" />
          <div className={styles.progress}>
            <div
              className={styles.progressBar}
              style={{
                width: `${((loops - pinnedLoops) / loops) * 100}%`,
              }}
            />
          </div>
        </Tooltip>
      );
      return (
        <OverlayTrigger
          placement="top"
          overlay={tooltip}
          trigger={['hover', 'focus']}
          delayHide={interval * 1000}
        >
          {refresher}
        </OverlayTrigger>
      );
    }

    const tooltip = (
      <Tooltip id="refresher-tooltip">
        <FormattedMessage id="lora.coms.refresher.tooltip" />
      </Tooltip>
    );
    return (
      <OverlayTrigger placement="top" overlay={tooltip} delayShow={1500}>
        {refresher}
      </OverlayTrigger>
    );
  }
}

RefreshBtn.propTypes = propTypes;
RefreshBtn.defaultProps = defaultProps;

export default connect()(
  injectIntl(CSSModules(RefreshBtn,
    styles,
    { allowMultiple: true },
  )));




// WEBPACK FOOTER //
// ./src/containers/Application/coms/ApplicationDetail/coms/DashBoardView/coms/RefreshBtn/index.jsx